import { formatPostStatusList } from "../components/MainContent/SMP/SMPAnalytics/SMPAnalyticsUtils";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initialState = {
    filterUpdated: 0,
    selectedPageOption: ["selectAll"],
    filters: {
        duration: "30",
    },
    schedulePostsAnalytics: {
        smpPostList: {},
        smpSchedulePostsLoading: false,
    },
    smpChartData: {},
    smpChartDataLoading: {},
    smpChartDataError: {},
    smpPostsPerformaceLoading: {},
    smpPostsPerformaceError: {},
    smpPostsPerformaceData: [],
    totalPublishedCount: 0,
    publishedOffset: 1,
};

const SMPAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SMP_ANALYTICS_SELECTED_PAGES":
            return (state = {
                ...state,
                selectedPageOption: action.payload,
                filterUpdated: state.filterUpdated + 1,
            });

        case "SMP_ANALYTICS_SET_FILTERS":
            return (state = {
                ...state,
                filters: action.payload.filters,
                filterUpdated: state.filterUpdated + 1,
            });

        case isPending("GET_SCHEDULED_POST_COUNTS"):
            return (state = {
                ...state,
                schedulePostsAnalytics: { ...state.schedulePostsAnalytics, smpSchedulePostsLoading: true },
            });

        case isFulfilled("GET_SCHEDULED_POST_COUNTS"): {
            // console.log("3366 updatinggggg reducer");
            // formatPostStatusList({ postList: action.payload?.data?.schedules });
            return (state = {
                ...state,
                schedulePostsAnalytics: { smpPostList: formatPostStatusList({ postList: action.payload?.data?.schedules }), smpSchedulePostsLoading: false },
            });
        }

        case isRejected("GET_SCHEDULED_POST_COUNTS"):
            return (state = {
                ...state,
                schedulePostsAnalytics: { ...state.schedulePostsAnalytics, smpPostList: [], smpSchedulePostsLoading: false },
            });

        case isPending("FETCH_SMP_ANALYTICS_CHART_DATA"): {
            const smpChartDataLoading = state.smpChartDataLoading;
            const smpChartDataError = state.smpChartDataError;

            smpChartDataLoading[action.chart] = true;
            smpChartDataError[action.chart] = null;

            return { ...state, smpChartDataLoading, smpChartDataError };
        }

        case isRejected("FETCH_SMP_ANALYTICS_CHART_DATA"): {
            const smpChartDataLoading = state.smpChartDataLoading;
            const smpChartDataError = state.smpChartDataError;

            smpChartDataLoading[action.chart] = false;
            smpChartDataError[action.chart] = action.payload;

            return { ...state, smpChartDataLoading, smpChartDataError };
        }

        case isFulfilled("FETCH_SMP_ANALYTICS_CHART_DATA"): {
            // case "SET_SMR_ANALYTICS_CHART_DATA":
            const smpChartDataLoading = state.smpChartDataLoading;
            const smpChartDataError = state.smpChartDataError;
            const smpChartData = state.smpChartData;

            smpChartDataLoading[action.chart] = false;
            smpChartDataError[action.chart] = null;
            smpChartData[action.chart] = action.payload;

            return { ...state, smpChartDataLoading, smpChartDataError, smpChartData };
        }

        case isPending("FETCH_SMP_ANALYTICS_POSTS"): {
            return { ...state, smpPostsPerformaceLoading: true, smpPostsPerformaceError: false };
        }
        case isFulfilled("FETCH_SMP_ANALYTICS_POSTS"): {
            // console.log("action.pay", action.payload);

            return {
                ...state,
                publishedOffset: action.payload?.offset,
                totalPublishedCount: action.payload?.hits?.total,
                smpPostsPerformaceData: action.payload?.hits?.hits || [],
                smpPostsPerformaceLoading: false,
                smpPostsPerformaceError: false,
            };
        }
        case isRejected("FETCH_SMP_ANALYTICS_POSTS"): {
            return { ...state, smpPostsPerformaceLoading: false, smpPostsPerformaceError: true };
        }

        default:
            return state;
    }
};
export default SMPAnalyticsReducer;
